import { render, staticRenderFns } from "./orderDetailChatList.vue?vue&type=template&id=c565d3fc&scoped=true"
import script from "./orderDetailChatList.vue?vue&type=script&lang=js"
export * from "./orderDetailChatList.vue?vue&type=script&lang=js"
import style0 from "./orderDetailChatList.vue?vue&type=style&index=0&id=c565d3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c565d3fc",
  null
  
)

export default component.exports